export type TransactionType = 'FACTURE' | 'SALAIRE' | 'DEPOT' | 'RETRAIT';

export interface ITransaction {
  id: string;
  type: TransactionType;
  date: string;
  montant: number;
  description: string;
  compteId: string;
  transactionStatus: string;
}

export const defaultTransaction: Readonly<ITransaction> = {
  id: null,
  type: 'FACTURE',
  date: '',
  montant: 0,
  description: '',
  compteId: null,
  transactionStatus: 'SUCCESS',
};
